import(/* webpackMode: "eager", webpackExports: ["AddRefIfNedded"] */ "/vercel/path0/node_modules/codehike/dist/code/pre-ref.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","Accordions"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/toc-clerk.js");
;
import(/* webpackMode: "eager", webpackExports: ["TocPopover","TocPopoverTrigger","TocPopoverContent","TOCItems","Toc"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tab","Tabs"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/tabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["I18nLabel"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/contexts/i18n.js");
;
import(/* webpackMode: "eager", webpackExports: ["Pre"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/mdx.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageBody","TocNav","PageArticle","Breadcrumb","LastUpdate","Footer"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/page.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnchorProvider"] */ "/vercel/path0/node_modules/fumadocs-ui/node_modules/fumadocs-core/dist/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CalloutContent"] */ "/vercel/path0/src/app/components/code/callout.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiCode"] */ "/vercel/path0/src/app/components/code/code.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RunableCode"] */ "/vercel/path0/src/app/components/code/code.runable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/vercel/path0/src/app/components/code/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InlineFold"] */ "/vercel/path0/src/app/components/code/fold.client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/code/mentions.css");
;
import(/* webpackMode: "eager", webpackExports: ["Mermaid"] */ "/vercel/path0/src/app/components/code/mermaid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WithClientNotes"] */ "/vercel/path0/src/app/components/code/notes.client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/code/notes.tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandBlock"] */ "/vercel/path0/src/app/components/code/terminal-command.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OutputBlock"] */ "/vercel/path0/src/app/components/code/terminal-output.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TerminalClient"] */ "/vercel/path0/src/app/components/code/terminal.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreWithRef"] */ "/vercel/path0/src/app/components/code/token-transitions.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocsFooter"] */ "/vercel/path0/src/app/components/docs-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditOnGithub"] */ "/vercel/path0/src/app/components/edit-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Rate"] */ "/vercel/path0/src/app/components/rate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/vercel/path0/src/app/components/scroll-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible","CollapsibleTrigger","CollapsibleContent"] */ "/vercel/path0/src/app/components/ui/collapsible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownEmbed"] */ "/vercel/path0/src/components/shared/MarkdownRenderer/components/MarkdownEmbed.tsx");
